import { render, staticRenderFns } from "./EventQuotaDialog.vue?vue&type=template&id=0d3b9832&scoped=true"
import script from "./EventQuotaDialog.vue?vue&type=script&lang=js"
export * from "./EventQuotaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b9832",
  null
  
)

export default component.exports